import { RJSFSchema } from '@rjsf/utils';

export const CartUpsellConfigSchema: RJSFSchema = {
    type: "object",
    properties: {
        cartType: { type: 'string', enum: ['', 'split-2', 'split-3'] },
    }
}